import { Injectable } from '@angular/core';
import { DeliveryZone } from '@delivery/const';
import { DeliveryActions, OccDeliveryZonesService } from '@delivery/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class DeliveryZonesEffects {
  loadDeliveryZones$: Observable<DeliveryActions.LoadDeliveryZonesSuccess | DeliveryActions.LoadDeliveryZonesFail> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(DeliveryActions.LOAD_DELIVERY_ZONES),
        map((action: DeliveryActions.LoadDeliveryZones) => action.meta.entityId),
        switchMap((id: string) =>
          this.occDeliveryZonesService.getDeliveryZones().pipe(
            map((data: DeliveryZone[]) => new DeliveryActions.LoadDeliveryZonesSuccess(data, id)),
            catchError((error) => of(new DeliveryActions.LoadDeliveryZonesFail(error, id))),
          ),
        ),
      ),
    );

  constructor(
    private actions$: Actions,
    private occDeliveryZonesService: OccDeliveryZonesService,
  ) {}
}
